import React from "react";

export default function About() {
  return (
    <main className="pt-32 pb-20" data-testid="about-page">
      <section className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <p className="label-luxe text-[#D4AF37] mb-3">Despre Casa Noastră</p>
        <h1 className="h-display text-5xl sm:text-7xl text-[#F8F4E6] mb-8">Patru Decenii<br/><em className="gold-gradient-text not-italic">de Pasiune</em></h1>
        <p className="text-lg text-[#A39E8A] leading-relaxed max-w-2xl mx-auto">
          Fondată în 1987, Johny's Antique Shop este una dintre cele mai respectate case de antichități din Europa de Est. Specializați în descoperirea, autentificarea și restaurarea pieselor cu valoare istorică inestimabilă.
        </p>
      </section>
      <section className="max-w-[1100px] mx-auto px-6 lg:px-12 mt-24 grid lg:grid-cols-2 gap-16 items-center">
        <img src="https://images.unsplash.com/photo-1687180497278-ca4d736ecc99?q=85" alt="" className="aspect-[4/5] object-cover" />
        <div>
          <p className="label-luxe text-[#D4AF37] mb-4">Filosofia Noastră</p>
          <h2 className="h-display text-4xl text-[#F8F4E6] mb-6">Fiecare obiect, o moștenire vie</h2>
          <p className="text-[#A39E8A] leading-relaxed mb-4">
            Credem că antichitatea autentică este mai mult decât un bun — este o conversație tăcută între epoci. De la mobilierul Empire francez la ceasurile elvețiene de manufactură, fiecare piesă selectată în casa noastră a trecut printr-un proces riguros de expertiză și certificare.
          </p>
          <p className="text-[#A39E8A] leading-relaxed">
            Colaborăm cu istorici, restauratori și case de licitație din Paris, Geneva, Viena și Londra, asigurând cea mai înaltă standardă de proveniență și autenticitate.
          </p>
        </div>
      </section>
      <section className="max-w-[1100px] mx-auto px-6 lg:px-12 mt-32 grid sm:grid-cols-3 gap-12 text-center">
        {[
          ["38+", "Ani de Experiență"],
          ["1200+", "Piese Vândute"],
          ["12", "Țări Reprezentate"],
        ].map(([n, l]) => (
          <div key={l}>
            <p className="font-serif text-6xl text-[#D4AF37]">{n}</p>
            <p className="label-luxe mt-3">{l}</p>
          </div>
        ))}
      </section>
    </main>
  );
}
